export const MEDICAL_MANAGEMENT = {
  id: 'medical_management',
  label: 'Travaglio a conduzione medica',
};

export const OBSTETRIC_MANAGEMENT = {
  id: 'obstetric_management',
  label: 'Travaglio a conduzione ostetrica',
};
